import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck, ClipLoader } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

import { saveAs } from "file-saver";
import {
    Document,
    Packer,
    Paragraph,
    Table,
    TableRow,
    TableCell,
    TextRun,
    AlignmentType,
    WidthType,
    VerticalAlign,
    ShadingType,
    HeightRule,
} from "docx";

function RiskDashboard() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })
    
    const [loading, setLoading] = useState(true)

    const [message, setMessage] = useState("")
    const [reload, setReload] = useState(false)

    
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])

    // ▼ 탭 상태 (가맹점 수정 / 정산주기 / PG정보)
    const [activeTab, setActiveTab] = useState("수기결제")
    const [listState, setListState] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("RM대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "RM대시보드"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const downloadWord = async () => {
        const heading = (text, size = 28) =>
            new Paragraph({
                children: [new TextRun({ text, bold: true, size })],
                alignment: AlignmentType.LEFT,
                spacing: { after: 200 },
                border: {
                    bottom: {
                        color: "000000",
                        space: 1,
                        value: "single",
                        size: 6,
                    },
                },
            });

        const label = (text) =>
            new Paragraph({
                children: [new TextRun({ text, bold: false, size: 24 })],
                alignment: AlignmentType.RIGHT,
            });

        const normalCell = (text, bold = false, color = "000000") =>
            new TableCell({
                children: [
                    new Paragraph({
                        children: [new TextRun({ text, bold, size: 24, color })],
                        alignment: AlignmentType.CENTER,
                    }),
                ],
                verticalAlign: VerticalAlign.CENTER,
            });

        const headerRow = (texts) =>
            new TableRow({
                children: texts.map((text) =>
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text, bold: true, size: 24 })],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                        verticalAlign: VerticalAlign.CENTER,
                        shading: {
                            fill: "D9D9D9",
                            type: ShadingType.CLEAR,
                            color: "auto",
                        },
                    })
                ),
            });

        const dataRow = (texts, colorIndex = []) =>
            new TableRow({
                children: texts.map((text, i) => {
                    const color = colorIndex.includes(i) ? "C00000" : "000000";
                    const bold = colorIndex.includes(i);
                    return normalCell(text, bold, color);
                }),
            });

        const doc = new Document({
            sections: [
                {
                    children: [
                        new Paragraph({
                            children: [new TextRun({ text: "일일 RM 점검 현황", bold: true, size: 36 })],
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 200 }
                        }),
                        label("점검일: 2025년 08월 05일"),
                        new Paragraph(" "),
                        new Paragraph(" "),
                        heading("금일 점검 요약", 26),
                        new Table({
                            rows: [
                                headerRow(["구분", "총 발생 건수", "처리 완료", "처리 중", "보류/반려"]),
                                dataRow(["고액 거래 발생", "12 건", "10 건", "1 건", "1 건"]),
                                dataRow(["이상 반복 거래 발생", "3 건", "1 건", "0 건", "2 건"]),
                                dataRow(["합계", "15 건", "11 건", "1 건", "3 건"]),
                            ],
                            width: { size: 100, type: WidthType.PERCENTAGE },
                        }),
                        new Paragraph(" "),
                        new Paragraph(" "),
                        heading("보류/반려 건 목록 (조치 필요)", 26),
                        new Table({
                            rows: [
                                headerRow(["구분", "가맹점명", "사유", "상태"]),
                                dataRow(["고액 거래", "알파상사", "거래 증빙 자료 미제출", "지급 보류"], [3]),
                                dataRow(["반복 거래", "베타게임즈", "이상 접속 패턴 확인됨", "모니터링 중"], [3]),
                                dataRow(["반복 거래", "감마컨텐츠", "동일 사용자 비정상 결제 시도", "지급 보류"], [3]),
                            ],
                            width: { size: 100, type: WidthType.PERCENTAGE },
                        }),
                        new Paragraph(" "),
                        new Paragraph(" "),
                        // 기존 이 부분
                        heading("금일 주요 조치사항", 26),
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "✓ (예시) '델타쇼핑' 고액 거래 건, 유선 확인 후 정상 처리 완료",
                                    size: 22,
                                }),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "✓ (예시) '세타스토어' 계약 만료 임박, 정산 안내 메일 발송",
                                    size: 22,
                                }),
                            ],
                        }),
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "✓ (예시) '알파상사' 증빙 자료 제출 요청 (2차)",
                                    size: 22,
                                }),
                            ],
                        }),

                    ],
                },
            ],
        });

        const blob = await Packer.toBlob(doc);
        saveAs(blob, "일일_RM_점검_현황_2025년_8월_5일.docx");
    };

    

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate, reload])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/rm/trx", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.reviews ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.reviews ?? []]);
                }
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const onSubmit = async (review_id, status) => {
        if (window.confirm("상태값을 변경하시겠습니까?")) {
            await axios.post(
                process.env.REACT_APP_API + "/api/rm/trx/status",
                {
                    review_id: review_id,
                    review_status: status,
                    memo: "",
                },
                {
                    withCredentials: true,
                }
            )
                .then((response) => {
                    let tmp = response?.data;
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setPage(1)
                        setReload((e) => !e);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    const tableHeaderData =
        [
            { "no": 0, "text": "확인", "width": "50px", "textAlign": "center" },
            { "no": 1, "text": "승인번호", "width": "80px", "textAlign": "center" },
            { "no": 2, "text": "가맹점명", "width": "200px", "textAlign": "center" },
            { "no": 3, "text": "금액", "width": "80px", "textAlign": "center" },
            { "no": 3, "text": "날짜", "width": "100px", "textAlign": "center" },
            { "no": 3, "text": "상태", "width": "120px", "textAlign": "center" },
        ]

    const [checkedIds, setCheckedIds] = useState([]);

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            setCombineList(listTrxData)

            for (let i = 0; i < listTrxData.length; i++) {
                let data = listTrxData[i]

                let rowData = [
                    {
                        "no": 0, "text": (
                            <input
                                type="checkbox"
                                checked={checkedIds.includes(data.review_id)}
                                onChange={(e) => {
                                    const { checked } = e.target;

                                    if (checked) {
                                        setCheckedIds(prev =>
                                            prev.includes(data.review_id) ? prev : [...prev, data.review_id]
                                        );
                                    } else {
                                        setCheckedIds(prev =>
                                            prev.filter(id => id !== data.review_id)
                                        );
                                    }
                                }}
                            />
                        ), "width": "50px", "textAlign": "center"
                    },
                    { "no": 1, "text": data.approval_id, "width": "80px", "textAlign": "center" },
                    { "no": 2, "text": data.co_nm, "width": "200px", "textAlign": "left" },
                    { "no": 3, "text": changeNum(Number(data.amount)), "width": "80px", "textAlign": "right" },
                    { "no": 3, "text": data.transaction_dt, "width": "100px", "textAlign": "center" },
                    {
                        "no": 3, "text": (
                            MyData?.role == "SUPER"
                                ?
                                data.review_status == "PENDING"
                                    ?
                                    <div
                                        className="flex justify-center items-center"
                                        style={{ gap: "15px" }}
                                    >
                                        <a
                                            className="delete flex items-center text-success pointer"
                                            onClick={() => onSubmit(data.review_id, "APPROVED")}
                                        >
                                            <SquareCheck width={15} height={15} /> 확인
                                        </a>
                                        <a
                                            className="delete flex items-center text-danger pointer"
                                            onClick={() => onSubmit(data.review_id, "REJECTED")}
                                        >
                                            <SquareX width={15} height={15} /> 반려
                                        </a>
                                    </div>
                                    :
                                    data.review_status == "APPROVED"
                                        ?
                                        <div
                                            className="flex justify-center items-center"
                                            style={{ gap: "15px" }}
                                        >
                                            <a
                                                className="delete flex items-center text-success pointer"
                                                style={{ color: "blue" }}
                                                onClick={() => onSubmit(data.review_id, "COMPLETED")}
                                            >
                                                <SquareCheck width={15} height={15} /> 승인
                                            </a>
                                            <a
                                                className="delete flex items-center text-danger pointer"
                                                onClick={() => onSubmit(data.review_id, "REJECTED")}
                                            >
                                                <SquareX width={15} height={15} /> 반려
                                            </a>
                                        </div>
                                        :
                                        data.review_status == "REJECTED"
                                            ?
                                            "정산 중지"
                                            :
                                            data.review_status == "COMPLETED"
                                                ?
                                                "승인 완료"
                                                :
                                                ""
                                :
                                data.review_status == "PENDING"
                                    ?
                                    <div
                                        className="flex justify-center items-center"
                                        style={{ gap: "15px" }}
                                    >
                                        <a
                                            className="delete flex items-center text-success pointer"
                                            onClick={() => onSubmit(data.review_id, "APPROVED")}
                                        >
                                            <SquareCheck width={15} height={15} /> 확인
                                        </a>
                                        <a
                                            className="delete flex items-center text-danger pointer"
                                            onClick={() => onSubmit(data.review_id, "REJECTED")}
                                        >
                                            <SquareX width={15} height={15} /> 반려
                                        </a>
                                    </div>
                                    :
                                    data.review_status == "APPROVED"
                                        ?
                                        "정산 대기"
                                        :
                                        data.review_status == "REJECTED"
                                            ?
                                            "정산 중지"
                                            :
                                            data.review_status == "COMPLETED"
                                                ?
                                                "승인 완료"
                                                :
                                                ""
                        ), "width": "120px", "textAlign": "center"
                    },
                ]

                rowData.id = data.id
                tableBodyData.push(rowData);
            }
            setListState(e => !e)
            setCombineData(tableBodyData)
        }
    }, [listTrxData, page, maxFirstPage, reload, checkedIds
        // selectedValue3, selectedText3,
    ])

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    const ChangeCheckStatus = () => {

    }
    const excelBtn = () => {

    }

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                    />
                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <div className='excel-disable' style={{ width: "auto" }}>
                        <div className="excel_download" onClick={downloadWord} style={{ opacity: "1", position: "relative" }}>
                            <img src='/img/word_img.png' className='btn btn-outline-secondary' style={{ height: "36px", padding: '0', cursor: "pointer" }} />
                        </div>
                    </div>
                </div>
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div className="p-6 text-sm text-gray-900 space-y-6 mt-5" style={{ border: "1px solid #e5e5e5", borderRadius: "5px" }}>
                        <h1 className="text-center text-xl font-bold mb-2">일일 RM 점검 현황</h1>
                        <p className="text-right">점검일: 2025년 08월 05일</p>

                        <section>
                            <h2 className="text-left font-bold border-b pb-1 mb-2">금일 점검 요약</h2>
                            <table className="w-full border border-gray-300 text-center text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border px-2 py-1">구분</th>
                                        <th className="border px-2 py-1">총 발생 건수</th>
                                        <th className="border px-2 py-1">처리 완료</th>
                                        <th className="border px-2 py-1">처리 중</th>
                                        <th className="border px-2 py-1">보류/반려</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border px-2 py-1">고액 거래 발생</td>
                                        <td className="border px-2 py-1">12 건</td>
                                        <td className="border px-2 py-1">10 건</td>
                                        <td className="border px-2 py-1">1 건</td>
                                        <td className="border px-2 py-1">1 건</td>
                                    </tr>
                                    <tr>
                                        <td className="border px-2 py-1">이상 반복 거래 발생</td>
                                        <td className="border px-2 py-1">3 건</td>
                                        <td className="border px-2 py-1">1 건</td>
                                        <td className="border px-2 py-1">0 건</td>
                                        <td className="border px-2 py-1">2 건</td>
                                    </tr>
                                    <tr className="font-semibold">
                                        <td className="border px-2 py-1">합계</td>
                                        <td className="border px-2 py-1">15 건</td>
                                        <td className="border px-2 py-1">11 건</td>
                                        <td className="border px-2 py-1">1 건</td>
                                        <td className="border px-2 py-1">3 건</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>

                        <section>
                            <h2 className="text-left font-bold border-b pb-1 mb-2">보류/반려 건 목록 (조치 필요)</h2>
                            <table className="w-full border border-gray-300 text-center text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border px-2 py-1">구분</th>
                                        <th className="border px-2 py-1">가맹점명</th>
                                        <th className="border px-2 py-1">사유</th>
                                        <th className="border px-2 py-1">상태</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="border px-2 py-1">고액 거래</td>
                                        <td className="border px-2 py-1">알파상사</td>
                                        <td className="border px-2 py-1">거래 증빙 자료 미제출</td>
                                        <td className="border px-2 py-1">지급 보류</td>
                                    </tr>
                                    <tr>
                                        <td className="border px-2 py-1">반복 거래</td>
                                        <td className="border px-2 py-1">베타게임즈</td>
                                        <td className="border px-2 py-1">이상 접속 패턴 확인됨</td>
                                        <td className="border px-2 py-1">모니터링 중</td>
                                    </tr>
                                    <tr>
                                        <td className="border px-2 py-1">반복 거래</td>
                                        <td className="border px-2 py-1">감마컨텐츠</td>
                                        <td className="border px-2 py-1">동일 사용자 비정상 결제 시도</td>
                                        <td className="border px-2 py-1">지급 보류</td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>

                        <section>
                            <h2 className="text-left font-bold border-b pb-1 mb-2">금일 주요 조치사항</h2>
                            <ul className="list-disc list-inside space-y-1">
                                <li style={{ listStyle: "none" }}>✓ (예시) '델타쇼핑' 고액 거래 건, 유선 확인 후 정상 처리 완료</li>
                                <li style={{ listStyle: "none" }}>✓ (예시) '세타스토어' 계약 만료 임박, 정산 안내 메일 발송</li>
                                <li style={{ listStyle: "none" }}>✓ (예시) '알파상사' 증빙 자료 제출 요청 (2차)</li>
                            </ul>
                        </section>
                    </div>
                    <div style={{ width: "100%", maxWidth: "650px" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"820px"}
                            spinner={spinner}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RiskDashboard